import {
  DEVICE_HIBERNATING,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
  DEVICE_STATUS_CLASSES,
} from "constant/device-status";
import get from "lodash/get";
import { defaultObject } from "redux-store/selectors";

function deviceStatusesSelector(state) {
  return get(state, "global.deviceStatuses.byId", defaultObject);
}

function getStatus(deviceStatus) {
  if (isHibernating(deviceStatus)) {
    return DEVICE_HIBERNATING;
  }

  return isOnline(deviceStatus) ? DEVICE_ONLINE : DEVICE_OFFLINE;
}

function getStatusClass(deviceStatus) {
  if (deviceStatus) {
    return deviceStatus.online
      ? DEVICE_STATUS_CLASSES.online
      : DEVICE_STATUS_CLASSES.offline;
  }

  return DEVICE_STATUS_CLASSES.unknown;
}

function isOnline(deviceStatus) {
  return Boolean(deviceStatus.online);
}

function isHibernating(deviceStatus) {
  return Boolean(deviceStatus.hibernating);
}

export {
  deviceStatusesSelector,
  getStatus,
  getStatusClass,
  isHibernating,
  isOnline,
};
